// extracted by mini-css-extract-plugin
module.exports = {"userMenu":"UserMenu_userMenu__2LkVo","wider":"UserMenu_wider__36tg6","dropdownItem":"UserMenu_dropdownItem__26SWo","dropdownIcon":"UserMenu_dropdownIcon__2MWfS"};